import React, { useState } from "react";

export function useConfirm() {
  const [confirmState, setConfirmState] = useState<{
    title: string;
    message: string;
    confirmLabel: string;
    onConfirm: () => void | Promise<void>;
  } | null>(null);

  function askConfirm(options: {
    title: string;
    message: string;
    confirmLabel?: string;
    onConfirm: () => void | Promise<void>;
  }) {
    setConfirmState({ confirmLabel: "Тийм", ...options });
  }

  const modal = confirmState ? (
    <div className="modal-backdrop" role="presentation">
      <div className="confirm-modal">
        <h2>{confirmState.title}</h2>
        <p>{confirmState.message}</p>
        <div>
          <button type="button" onClick={() => setConfirmState(null)}>
            Буцах
          </button>
          <button
            className="danger-button"
            type="button"
            onClick={async () => {
              const action = confirmState.onConfirm;
              setConfirmState(null);
              await action();
            }}
          >
            {confirmState.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  ) : null;

  return { askConfirm, confirmModal: modal };
}
